import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { copy } from '../lib/clipboard';
import { hapticLight } from '../lib/haptics';

/**
 * TapCopy (TCH-005) — wrappe une valeur copiable (TikTok ID, pseudo, montant, ID).
 * Tap → clipboard + toast "✓ Copié" 1.5s. No-op haptique sur web.
 *
 *   <TapCopy value={creator.tiktok_id} title="Tap pour copier le TikTok ID">
 *     <span>{creator.tiktok_id}</span>
 *   </TapCopy>
 */
const TapCopy = ({ value, children, className = '', style, title }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(
    async (e) => {
      e?.stopPropagation?.();
      if (!value) return;
      const r = await copy(value);
      if (r.ok) {
        hapticLight();
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }
    },
    [value],
  );

  return (
    <span
      role="button"
      onClick={handleCopy}
      title={title || `Copier : ${value}`}
      className={className}
      style={{
        cursor: 'pointer',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        ...style,
      }}
    >
      {children}
      {copied && (
        <span
          aria-live="polite"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(34,197,94,0.92)',
            color: '#fff',
            fontSize: 11,
            fontWeight: 600,
            padding: '4px 10px',
            borderRadius: 6,
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
            fontFamily: 'Inter, sans-serif',
            zIndex: 10,
          }}
        >
          {t('common.copied', '✓ Copié')}
        </span>
      )}
    </span>
  );
};

export default TapCopy;
